import { t } from '@lingui/macro'
import { Button, TextField } from '@material-ui/core'
import { useStateRef } from '@speedlo/hooks'
import { css } from 'emotion'
import React, { useCallback } from 'react'
import * as Yup from 'yup'

import { i18n } from '../i18n'

interface IProps {
  buttonText: string
  emailInvalid?: boolean
  disabled?: boolean
  onSubmit(email: string): void
}

const formReset = css`
  display: contents;
`

const isEmail = Yup.string()
  .required()
  .email()

export const LoginForm: React.FC<IProps> = ({
  onSubmit,
  buttonText,
  emailInvalid = false,
  disabled = false,
}) => {
  const [getEmail, setEmail] = useStateRef('')
  const validates = useCallback(() => {
    return isEmail.isValidSync(getEmail().trim())
  }, [])
  return (
    <form
      className={formReset}
      onSubmit={ev => {
        if (validates()) {
          onSubmit(getEmail().trim())
        }
        ev.preventDefault()
      }}
    >
      <TextField
        id="email"
        autoComplete="email"
        label={i18n._(t`Email`)}
        disabled={disabled}
        error={emailInvalid}
        onChange={ev => setEmail(ev.target.value)}
        required
      />
      <br />
      <Button
        type="submit"
        variant="contained"
        disabled={disabled || !validates()}
      >
        {buttonText}
      </Button>
    </form>
  )
}
